var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 5.75588C18.332 6.20774 17.9657 6.57405 17.5138 6.57405C17.0619 6.57405 16.6956 6.20774 16.6956 5.75588M18.332 5.75588C18.332 5.30402 17.9657 4.93771 17.5138 4.93771C17.0619 4.93771 16.6956 5.30402 16.6956 5.75588M18.332 5.75588H16.6956M16.6117 2H7.38827C4.41213 2 2 4.41255 2 7.38826V16.6117C2 19.5879 4.41256 22 7.3887 22H16.6113C19.5875 22 22 19.5874 22 16.6113V7.38826C22 4.41213 19.5879 2 16.6117 2ZM16.8278 12C16.8278 14.6662 14.6663 16.8277 12.0001 16.8277C9.33384 16.8277 7.17241 14.6662 7.17241 12C7.17241 9.33374 9.33384 7.17231 12.0001 7.17231C14.6663 7.17231 16.8278 9.33374 16.8278 12Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLine);
export default __webpack_public_path__ + "static/media/instagram_line.37ecf85f5bd4976e121afe1ff373c2d1.svg";
export { ForwardRef as ReactComponent };